(function () {
  function setActive(btn) {
    const wrap = btn.closest('[data-card-swatches]');
    if (!wrap) return;
    wrap.querySelectorAll('[data-variant-swatch]').forEach(b => b.classList.remove('is-active'));
    btn.classList.add('is-active');
  }

  function swapCardImage(btn) {
    const card = btn.closest('.card-wrapper');
    if (!card) return;

    // 主图：取 card__media 内第一个 img（Dawn 结构就是这样）
const img = card.querySelector('.card__media .media img:nth-of-type(2)');
    if (!img) return;

    const src = btn.dataset.variantImageSrc;
    const srcset = btn.dataset.variantImageSrcset;
    const alt = btn.dataset.variantImageAlt || img.alt;

    if (src) img.src = src;
    if (srcset) img.srcset = srcset;
    img.alt = alt;

    // 可选：把卡片链接也改成带 variant 参数（更符合用户预期）
    const url = btn.dataset.variantUrl;
    if (url) {
      const link = card.querySelector('a[id^="CardLink-"], a[id^="StandardCardNoMediaLink-"]');
      if (link) link.href = url;
    }

    setActive(btn);
  }

  function bind(root) {
    root.querySelectorAll('[data-variant-swatch]').forEach((btn) => {
      // 移动端：touchstart 更跟手
      btn.addEventListener('touchstart', (e) => {
        e.preventDefault();
        swapCardImage(btn);
      }, { passive: false });

      // 点击切换
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        swapCardImage(btn);
      });

      // 桌面端：悬停预览（可按需删掉）
      btn.addEventListener('pointerenter', () => {
        if (window.matchMedia('(hover: hover)').matches) {
          swapCardImage(btn);
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => bind(document));

  // 如果你有分页/筛选等局部刷新（section rendering），可以在外面手动调用：
  // window.bindCardVariantSwatches = bind;
})();
